module.exports = __webpack_public_path__ + "img/06_i.a5fb8250.webp";